import { createContext } from "react";
function getIt(serviceIdentifier) {
  return {};
}
export var GetItContext = /*#__PURE__*/createContext(getIt);